module.exports = "../study/imgs/maps/Nagano/S8/Ecosystem/Qacuta/Nagano_Qacuta_MRI_RCP26_Now.png";